export enum AuthOptions {
  Password = 'password',
  MagicLink = 'magicLink',
}
